var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "supportConfirm" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [_vm._v("送信完了")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c("div", [
              _c("section", { staticClass: "support_section" }, [
                _c("div", { staticClass: "support_complete_area" }, [
                  _c("div", { staticClass: "support_complete" }, [
                    _vm._v(
                      "\n              お問い合わせを送信しました。\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn_pos_center btn_color support_btn",
                      on: {
                        click: function($event) {
                          _vm.top()
                        }
                      }
                    },
                    [_vm._v("トップページ")]
                  )
                ])
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f4cb54c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f4cb54c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcSupportComplete.vue
// module id = null
// module chunks = 